// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"22c0e0e9","176":"8dbb6672","186":"cc34b35b","319":"bd568d48","395":"b082b6e4","551":"22d6bca8"}[chunkId] + ".chunk.js";
};